import Img1 from '../Assets/horiflat.jpg'
import Img2 from '../Assets/gow2.jpg'
import Img3 from '../Assets/tomclancy2.jpg'
import Img4 from '../Assets/lego.jpg'
import Img5 from '../Assets/eldenn.png'
import Img6 from '../Assets/mk11.jpg'
import Img7 from '../Assets/borderlands3.jpg'
import Img8 from '../Assets/ghostwire.jpg'

const Data = [
    {
        id: 1,
        title:" Horizon Forbidden West",
        genre: "Action-adventure",
        price: "$50.00",
        info: "New",
        img: Img1,
        category: "trending"
    },
    {
        id: 2,
        title:" God of War Ragnarok",
        genre: "Action-adventure",
        price: "$13.99",
        info: "New",
        img: Img2,
        category: "trending"
    },
    {
        id: 3,
        title:"Tom Clancy's Rainbow Six Extraction",
        genre: "Tactical shooter",
        price: "$39.00",
        info: "Top",
        img: Img3,
        category: "trending"
    },
  
    {
        id: 4,
        title:"LEGO star Wars; The Skywalker Saga",
        genre: "Action-adventure",
        price: "$40.00",
        info: "Top",
        img: Img4,
        category: "newReleases"
    },
  
    {
        id: 5,
        title:"EldenRing",
        genre: "Tactical shooter",
        price: "$29.99",
        info: "Top",
        img: Img5,
        category: "BestRated"
    },
    {
        id: 6,
        title:"Mortal Kombat 11",
        genre: "Fghting game",
        price: "$25.99",
        info: "Top",
        img: Img6,
        category: "BestRated"
    },
    {
        id: 7,
        title:"Borderlands3",
        genre: "Action role-playing, first-person shooter",
        price: "$19.99",
        info: "Top",
        img: Img7,
        category: "BestRated"
    },
    {
        id: 8,
        title:"Ghost wire: Tokyo",
        genre: "Action-adventure",
        price: "$60.00",
        info: "Top",
        img: Img8,
        category: "newReleases"
    },
  
]

export default Data;